import { render, staticRenderFns } from "./RelatorioAtendimento.vue?vue&type=template&id=256e8f34"
import script from "./RelatorioAtendimento.vue?vue&type=script&lang=js"
export * from "./RelatorioAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports